import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/Navbar";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-obsidian bg-grain">
      <Navbar />
      <div className="max-w-lg mx-auto px-5 sm:px-8 pt-40 pb-20 text-center">
        <div className="glass-card rounded-2xl p-8" data-testid="payment-cancel">
          <XCircle className="w-10 h-10 text-slate-400 mx-auto mb-5" />
          <h1 className="font-serif text-2xl sm:text-3xl text-gold-light">Payment cancelled</h1>
          <p className="text-slate-400 mt-3">
            Your message wasn't sealed and you weren't charged. You can record again whenever you're ready.
          </p>
          <Button
            data-testid="cancel-record-again-button"
            onClick={() => navigate("/record")}
            className="mt-7 rounded-full bg-gold hover:bg-gold-hover text-obsidian font-semibold px-7 h-12"
          >
            Record my message
          </Button>
        </div>
      </div>
    </div>
  );
}
